import React, { Fragment, Component } from 'react';
import { Trans } from 'react-i18next';
import { compose } from 'recompose';
import { MutationFunction } from 'react-apollo';
import { Grid, Link, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { MarkInboxAsReadComponent } from 'api';
import { Notifications as NotificationsLink } from 'Links';
import { EmptyState } from 'components';
import { withInboxItems, IWithInboxItems } from 'providers/queries';
import { markInboxAsReadResponse } from 'apollo/responses';
import { markRead } from 'apollo/reducers';

import { POPUP_LIMIT } from '../constants';
import Notification from '../components/Notification';

interface IProps {
  onClick: () => void;
}

interface IPropsEnhanced extends IProps, IWithInboxItems, WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    menu: {
      width: 300,
    },
    common: {
      padding: '12px 24px',
      outline: 'none',
    },
    header: {
      borderBottom: `1px solid ${theme.custom.palette.grey3}`,
    },
    footer: {
      borderTop: `1px solid ${theme.custom.palette.grey3}`,
    },
  });

const enhancers = compose<IPropsEnhanced, IProps>(
  withInboxItems({ loader: 'none', limit: POPUP_LIMIT }),
  withStyles(styles),
);

class NotificationsPopup extends Component<IPropsEnhanced> {
  handleMarkAllRead = (markInboxAsRead: MutationFunction) => () => {
    return markInboxAsRead({
      optimisticResponse: markInboxAsReadResponse(),
      update: markRead,
    });
  };

  renderHeader() {
    const { classes } = this.props;
    const headerClasses = classNames(classes.common, classes.header);

    return (
      <div className={headerClasses}>
        <Grid container alignItems="center" justify="space-around">
          <Grid item xs>
            <Typography variant="subtitle2">
              <Trans i18nKey="common:notification_plural" />
            </Typography>
          </Grid>
          <Grid item>
            <MarkInboxAsReadComponent>
              {markInboxAsRead => (
                <Link component="button" onClick={this.handleMarkAllRead(markInboxAsRead)}>
                  <Trans i18nKey="components:markRead" />
                </Link>
              )}
            </MarkInboxAsReadComponent>
          </Grid>
        </Grid>
      </div>
    );
  }

  renderFooter() {
    const { classes, onClick } = this.props;
    const footerClasses = classNames(classes.common, classes.footer);

    return (
      <div className={footerClasses}>
        <Grid container alignItems="center" justify="space-around">
          <Grid item>
            <Link component={NotificationsLink} onClick={onClick}>
              <Trans i18nKey="components:seeAll" />
            </Link>
          </Grid>
        </Grid>
      </div>
    );
  }

  render() {
    const { inbox, onClick } = this.props;

    return (
      <Fragment>
        {this.renderHeader()}
        {!inbox.length && <EmptyState fullWidth name="notificationPop" />}
        {inbox.map(item => (
          <Notification
            onClick={onClick}
            theme="default"
            key={item.id}
            size="regular"
            item={item}
          />
        ))}
        {this.renderFooter()}
      </Fragment>
    );
  }
}

export default enhancers(NotificationsPopup);
